var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76087 0C3.48156 0 0 3.27653 0 7.30383C0 12.3657 7.7685 21.0125 7.7685 21.0125C7.7685 21.0125 15.5217 12.1168 15.5217 7.30383C15.5217 3.27653 12.0403 0 7.76087 0ZM10.1025 9.44239C9.45682 10.0499 8.60891 10.3537 7.76087 10.3537C6.91297 10.3537 6.06479 10.0499 5.41939 9.44239C4.12818 8.22736 4.12818 6.25026 5.41939 5.03509C6.04462 4.44642 6.87631 4.12221 7.76087 4.12221C8.64543 4.12221 9.47699 4.44655 10.1025 5.03509C11.3937 6.25026 11.3937 8.22736 10.1025 9.44239Z",
    fill: "#9C7D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.c0b08f21b32f1609b03d702b114c37ab.svg";
export { ForwardRef as ReactComponent };